/**
 * Scroll-driven background zoom (aligned with editorial-experience.js hero / closing frame: same smoothstep + 0.88 span).
 * Used by: collection LV banner, secondary-page banner (banner-about, page-breadcrumb-banner),
 * Hero Banner (banner-video-background).
 */
(function () {
  'use strict';

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function smoothstep(t) {
    t = clamp(t, 0, 1);
    return t * t * (3 - 2 * t);
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /** Same idea as editorial updateHero: measure scroll progress from the outer hero shell, not only the inner frame. */
  function getMeasurementHost(frame) {
    var hero = frame.closest('.hero-media-banner');
    if (hero) return hero;

    var wrapCrumb = frame.closest('.wrap-bread-crumb.banner_abbout');
    if (wrapCrumb) {
      var bg = wrapCrumb.querySelector('.bg-breadcrumb');
      if (bg) return bg;
    }

    var fig = frame.closest('figure.tcn-coll-lv__banner');
    if (fig) return fig;

    return frame;
  }

  function updateAll() {
    var inners = document.querySelectorAll('[data-tcn-coll-lv-banner-inner]');
    if (!inners.length) return;

    if (prefersReducedMotion()) {
      inners.forEach(function (inner) {
        inner.style.transform = '';
      });
      return;
    }

    inners.forEach(function (inner) {
      var frame = inner.closest('.tcn-coll-lv__banner-frame');
      var root = inner.closest('[data-tcn-coll-lv]');
      if (!frame || !root) return;

      var zoomPct = parseFloat(root.getAttribute('data-tcn-coll-lv-banner-zoom'), 10);
      if (isNaN(zoomPct)) zoomPct = 8;

      var host = getMeasurementHost(frame);
      var h = host.offsetHeight;
      if (h <= 0) return;

      var top = host.getBoundingClientRect().top;
      var progress = clamp(-top / Math.max(h * 0.88, 1), 0, 1);
      var eased = smoothstep(progress);
      var scale = 1 + (zoomPct / 100) * eased;
      inner.style.transform = 'scale(' + scale + ')';
    });
  }

  if (!document.querySelector('[data-tcn-coll-lv-banner-inner]')) return;

  if (window.__tcnCollLvBannerZoomInit) return;
  window.__tcnCollLvBannerZoomInit = true;

  var ticking = false;
  function onScrollOrResize() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateAll();
      });
    }
  }

  updateAll();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });

  try {
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', updateAll);
  } catch (e) {
    /* older browsers */
  }

  document.addEventListener('shopify:section:load', function () {
    requestAnimationFrame(updateAll);
  });
  document.addEventListener('shopify:section:unload', function () {
    requestAnimationFrame(updateAll);
  });
})();
